export const MODAL_IDS = {
  FOLLOWERS: 'profile-followers',
  FOLLOWING: 'profile-following',
};

export const ICON_FAMILY = {
  solid: 'fa-solid',
  regular: 'fa-regular',
  brands: 'fa-brands',
};

export const PROFILE_STATS = [
  { id: 'realty', kind: 'link', href: '#profile-objects', valueKey: 'realtyCount', labelText: 'Нерухомість' },
  { id: 'followers', kind: 'modal-trigger', modalId: 'profile-followers', valueKey: 'followers', labelText: 'Підписники' },
  { id: 'following', kind: 'modal-trigger', modalId: 'profile-following', valueKey: 'following', labelText: 'Підписки' },
];

export const PROFILE_ACTIONS = {
  primary: [
    { id: 'follow', label: 'Підписатися', icon: 'fa-user-plus', kind: 'button', variant: 'filled' },
    { id: 'message', label: 'Повідомлення', icon: 'fa-paper-plane', kind: 'button' },
  ],
  secondary: [
    { id: 'edit', label: 'Редагувати', icon: 'fa-pen-to-square', kind: 'link', href: 'profile/edit' },
    { id: 'saved', label: 'Збережені', icon: 'fa-bookmark', kind: 'link', href: 'saved.html' },
    { id: 'stats', label: 'Статистика', icon: 'fa-chart-line', kind: 'link', href: 'statistics.html' },
    { id: 'pay', label: 'Оплата', icon: 'fa-credit-card', kind: 'link', href: 'payPage.html' },
    { id: 'phone', label: 'Телефон', icon: 'fa-phone', kind: 'link', hrefFromContact: 'phone' },
    { id: 'email', label: 'Email', icon: 'fa-envelope', kind: 'link', hrefFromContact: 'email' },
  ],
};

export const PROFILE_MENU = [
  { id: 'share', label: 'Поширити', icon: 'fa-share-nodes', kind: 'button' },
  { id: 'help', label: 'Допомога', icon: 'fa-circle-question', kind: 'button' },
  { id: 'info', label: 'Інфо', icon: 'fa-circle-info', kind: 'button' },
  { id: 'settings', label: 'Налаштування', icon: 'fa-gear', kind: 'button' },
  { id: 'more', label: 'Більше', icon: 'fa-ellipsis', kind: 'button' },
  // { id: 'logout', label: 'Вийти', icon: 'fa-arrow-right-from-bracket', kind: 'link', href: 'login.html', danger: true },
];
